import React, { useState, useEffect } from 'react';
import ProductCardDesktop from './ProductCardDesktop';
import ProductCardMobile from './ProductCardMobile';

function getWindowWidth() {
  return typeof window !== 'undefined' ? window.innerWidth : 1024;
}

function ProductCard({ product }) {
  const [width, setWidth] = useState(getWindowWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = width <= 768;

  return isMobile ? (
    <ProductCardMobile product={product} />
  ) : (
    <ProductCardDesktop product={product} />
  );
}

export default ProductCard;